
import { actions, types } from './requests'
export const GETDATAIMPORTLIST_TYPES = {
    ...types('GETDATAIMPORTLIST'),
}
export const GETDATAIMPORTLIST_ACTIONS = {
    ...actions('GETDATAIMPORTLIST'),
}